var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconCandle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 54,
    viewBox: "0 0 53 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_29_1818)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.0356 7.55499H15.6772V2.57829C15.6772 1.68436 14.9528 0.961792 14.0589 0.961792C13.165 0.961792 12.4406 1.68613 12.4406 2.57829V7.55499H9.08219C7.70773 7.55499 6.59473 8.66976 6.59473 10.0425V39.9009C6.59473 41.2754 7.70949 42.3884 9.08219 42.3884H12.4406V52.3418C12.4406 53.2357 13.165 53.96 14.0589 53.96C14.9528 53.96 15.6772 53.2357 15.6772 52.3418V42.3884H19.0356C20.4101 42.3884 21.5231 41.2736 21.5231 39.9009V10.0442C21.5231 8.66976 20.4083 7.55676 19.0356 7.55676V7.55499Z",
    fill: "#FF7324"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.9174 15.0209H40.559V2.57829C40.559 1.68436 39.8347 0.961792 38.9407 0.961792C38.0468 0.961792 37.3225 1.68613 37.3225 2.57829V15.0192H33.964C32.5896 15.0192 31.4766 16.1339 31.4766 17.5066V29.9475C31.4766 31.322 32.5913 32.435 33.964 32.435H37.3225V52.3418C37.3225 53.2357 38.0468 53.96 38.9407 53.96C39.8347 53.96 40.559 53.2357 40.559 52.3418V32.435H43.9174C45.2919 32.435 46.4049 31.3202 46.4049 29.9475V17.5066C46.4049 16.1322 45.2901 15.0192 43.9174 15.0192V15.0209Z",
    fill: "#FF7324"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_29_1818"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 53,
    height: 53,
    fill: "white",
    transform: "translate(0 0.961792)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCandle);
export default __webpack_public_path__ + "static/media/IconCandle.4d180994f04803a82338f89a87d779eb.svg";
export { ForwardRef as ReactComponent };